import { Pipe, PipeTransform } from '@angular/core';
import { InputRow } from '../base-table.interface';

export type RowFilter<T> = (row: T) => boolean;

@Pipe({ name: 'tableFilter' })
export class TableFilterPipe<T, G, E> implements PipeTransform {
    public transform(
        values: InputRow<T, G, E>[] | null | undefined,
        filters: RowFilter<InputRow<T, G, E>>[]
    ): unknown {
        if (!values) {
            return values;
        }

        return values.map((value) => {
            // TODO check if type definitions for tables can be adapted accordingly
            (value as any).isFiltered = !!filters?.length && !filters.every((filter) => filter(value));

            return value;
        });
    }
}
